import type { User } from '@/types'

export const AUTH_STORAGE_KEY = 'auth'

/** Buffer before JWT expiry when treating the session as expired */
export const TOKEN_EXPIRY_BUFFER_MS = 5 * 60 * 1000

export interface AuthData {
  token: string
  user: User
  expiresAt: number
}
